function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.945 2.293a1 1 0 011.176-.177C26.806 4.598 30 9.526 30 15.201 30 23.373 23.374 30 15.202 30c-5.676 0-10.604-3.195-13.086-7.88a1 1 0 011.352-1.351 12.75 12.75 0 005.984 1.481c7.068 0 12.798-5.73 12.798-12.8 0-2.162-.535-4.197-1.48-5.982a1 1 0 01.175-1.175zm2.823 3.399c.315 1.2.482 2.461.482 3.759 0 8.174-6.625 14.8-14.798 14.8a14.82 14.82 0 01-3.76-.483A12.768 12.768 0 0015.202 28C22.27 28 28 22.269 28 15.2c0-3.772-1.632-7.165-4.232-9.508z",
  fill: "currentColor"
})));